if (typeof HTMLVideoElement.prototype.requestFullscreen === 'undefined') {
  HTMLVideoElement.prototype.requestFullscreen = (
    HTMLVideoElement.prototype.mozRequestFullScreen ||
    HTMLVideoElement.prototype.webkitEnterFullscreen ||
    HTMLVideoElement.prototype.webkitRequestFullScreen ||
    HTMLVideoElement.prototype.msRequestFullscreen
  )
}
